// import cl from 'classnames'
import {
  Button,
  GalleryDropZone,
  GalleryDropZoneRef,
  H2,
  IconEdit, SectionContainer
} from '@touche-lts/panel-ui/dist'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useRef, useState } from 'react'
import styles from './store-image-section.module.scss'
import { StoreImageSectionProps } from './store-image-section.types'

const StoreImageSectionComponent = (props: StoreImageSectionProps) => {
  const [editMode, setEditMode] = useState<boolean>(false)
  const gallery: GalleryDropZoneRef = useRef()

  const onCancelEditClick = () => {
    setEditMode(false)
  }
  const onSaveClick = async () => {
    await gallery.current.handleImages()
    const images = gallery.current.getImages()
    await updateImages(images)
    setEditMode(false)
  }

  const {
    viewStorePageStore: { store, updateImages },
    generalStore: {
      api: { uploadFileSigned }
    }
  } = useRootStore()

  return (
    <SectionContainer colorPreset='dark' {...props}>
      <H2 colorPreset='dark' className={styles.heading}>
        Images
        {editMode ? (
          <div className={styles.headingButtonsContainer}>
            <Button
              preset='secondary'
              colorPreset='dark'
              onClick={onCancelEditClick}
            >
              Cancel
            </Button>
            <Button preset='primary' onClick={onSaveClick}>
              Save
            </Button>
          </div>
        ) : (
          <Button preset='icon' onClick={() => setEditMode(true)}>
            <IconEdit fill={styles.white} />
          </Button>
        )}
      </H2>
      <div className={styles.imageContainer}>

        {editMode ? (
          <div className={styles.upload}>
            <GalleryDropZone
              ref={gallery}
              colorPreset='dark'
              initialImages={store?.images || []}
              uploadFile={uploadFileSigned}
            />
          </div>
        ) : (
          <div className={styles.wrapper}>
            <GalleryDropZone
              ref={gallery}
              colorPreset='dark'
              initialImages={store?.images || []}
              uploadFile={uploadFileSigned}

            />
          </div>
        )}
      </div>
      {/* <div className={styles.imageContainer}>
        {editMode ? <GalleryDropZone
          ref={gallery}
          colorPreset='dark'
          initialImages={store?.images || []}
          uploadFile={uploadFileSigned}
        /> : <div className={styles.imageContainer}>
          {store?.images &&
            store?.images.map(image => (
              <ImagePortrait key={image.id} src={image.url} width={94} />
            ))}
        </div>}

      </div> */}
    </SectionContainer>
  )
}

const StoreImageSection = observer(StoreImageSectionComponent)
export { StoreImageSection }
